export default "__VITE_ASSET__25452736__"